<template>
  <div>
    <div class="code-wapper">
		<img :src="code_url" alt="">
	</div>
	<div class="code-info">请扫描付款码</div>
	<div class="code-btn" @click="goOrderDetail()">查看订单详情</div>
  </div>
</template>

<script>
import { cashierOrderStatus } from "@api/order";
const NAME = "PayQRcode";
export default {
  name: NAME,
  data: function() {
    return {
	  code_url: this.$route.query.code_url,
	  orderid: this.$route.params.orderid,
	  uid: this.$route.params.uid,
	  isJump: false
    };
  },
  watch: {
    $route(n,from) {
	  this.isPay();
	  this.$dialog.loading.open("加载中");
    }
  },
  mounted: function() {
	this.isPay();
	this.$dialog.loading.open("加载中");
  },
  methods: {
	isPay(){
		let that = this,
		  orderid = that.orderid;
		const time = setInterval(function(){
			cashierOrderStatus(orderid).then(res => {
				that.$dialog.loading.close();
				if(res.msg == '订单已支付'){
					that.$dialog.success(res.msg);
					that.$router.replace('/user/scan_order_details/' + orderid + '?uid=' + that.uid);
					window.clearInterval(time);
				}
				if(that.isJump){
					window.clearInterval(time);
					that.$router.replace('/user/scan_order_details/' + orderid + '?uid=' + that.uid);
				}
			}).catch(err => {
				that.$dialog.error(err.msg);
				that.$router.replace('/user/scan_order_details/' + orderid + '?uid=' + that.uid);
			})
		},2000);
	},
	goOrderDetail(){
		this.isJump = true;
		this.isPay();
	}
  }
};
</script>
<style scoped>
.code-wapper{
	width: 5rem;
	height: 5rem;
	margin: 0 auto;
	margin-top: 30%;
	border: 1px solid #333;
}
.code-wapper img{
	width: 100%;
}
.code-info{
	margin-top: 0.3rem;
	text-align: center;
	font-size: 0.3rem;
}
.code-btn{
	background-color: #e93323;
	color: #fff;
	width: 90%;
	height: 0.8rem;
	margin: 0 auto;
	margin-top: 0.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0.4rem;
	font-size: 0.3rem;
}
</style>